import { render } from "./LeftArrow.vue?vue&type=template&id=ffdd47a4"
import script from "./LeftArrow.vue?vue&type=script&lang=js"
export * from "./LeftArrow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__